// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"SearchFormContainer_searchContainer__1MjP4","searchTitle":"SearchFormContainer_searchTitle__33pPc","searchSubtitle":"SearchFormContainer_searchSubtitle__3-4_z"};